import { Component } from '@angular/core';
import { MaterialModule } from './module/material/material.module';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [MaterialModule,RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {}